import { useEffect } from "react";
import "./App.css";
import "./services/i18n";
import { store } from "./store/store";
import { Provider } from "react-redux";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ROUTES from "./services/AppConstant";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import Navigation from "./components/Navigation";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    const lang = JSON.parse(storedLanguage);
    if (storedLanguage) {
      i18n.changeLanguage(lang?.code);
    }
  }, []);

  // useEffect(() => {
  //   if (location?.pathname !== ROUTE.BOOK_SEARCH) {
  //     context.setSearch("");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [location]);

  // useEffect(() => {
  //   checkUserLogin();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // const checkUserLogin = async () => {
  //   const user = await getFromAsync(SESSION_KEY.USER_DATA);
  //   if (user?.GetNewPassword !== undefined && !user?.GetNewPassword) {
  //     if (location.pathname === ROUTE?.LOGIN) {
  //       navigate(ROUTE?.DASHBOARD);
  //     }
  //   } else {
  //     navigate(ROUTE?.LOGIN);
  //   }
  // };

  return (
    <div className="App">
      <ToastContainer />
      <Provider store={store}>
        <div className="w-full">
          {location?.pathname !== ROUTES?.LOGIN && <Header />}
          <Navigation />
          {location?.pathname !== ROUTES?.LOGIN && <Footer />}
          {location?.pathname !== ROUTES?.LOGIN && <ScrollToTop />}
        </div>
      </Provider>
    </div>
  );
}

export default App;
